import React from "react";
import { Alert, Typography } from "antd";

const { Title, Paragraph, Text } = Typography;

const ApiGettingStarted = () => {
  return (
    <div className="api-doc-section">
      <Title level={4}>Quick Start Guide</Title>

      <Paragraph type="secondary">
        Connect your website, landing page, or external application
        to the CRM using the REST API.
      </Paragraph>

      <Title level={5}>1. Generate an API Key</Title>

      <Paragraph>
        Open the <Text strong>API Keys</Text> section and generate
        a key with the permissions required by your integration.
      </Paragraph>

      <Alert
        type="warning"
        showIcon
        message="Store your API key securely"
        description="The complete API key is displayed only once after generation. Never expose it in browser-side JavaScript or public source code."
        style={{ marginBottom: 24 }}
      />

      <Title level={5}>2. Authenticate Requests</Title>

      <Paragraph>
        Include your API key as a Bearer token:
      </Paragraph>

      <pre className="api-code-block">
{`Authorization: Bearer ferp_live_your_api_key
Content-Type: application/json`}
      </pre>

      <Title level={5}>3. Fetch CRM Reference IDs</Title>

      <Paragraph>
        Before creating leads, fetch the branch-specific statuses,
        sources, purposes and custom fields.
      </Paragraph>

      <pre className="api-code-block">
{`GET /api/v1/meta`}
      </pre>

      <Paragraph>
        Use the returned IDs when sending values such as:
      </Paragraph>

      <pre className="api-code-block">
{`{
  "status_id": "STATUS_UUID",
  "source_id": "SOURCE_UUID",
  "purpose_id": "PURPOSE_UUID"
}`}
      </pre>

      <Title level={5}>4. Create a Lead</Title>

      <pre className="api-code-block">
{`POST /api/v1/leads

{
  "name": "John Doe",
  "phone": "+971500001234",
  "email": "john@example.com",
  "source_id": "SOURCE_UUID",
  "status_id": "STATUS_UUID",
  "purpose_id": "PURPOSE_UUID"
}`}
      </pre>

      <Title level={5}>5. Handle Responses</Title>

      <Paragraph>
        Successful lead creation returns the generated lead ID and
        resolved status ID.
      </Paragraph>

      <pre className="api-code-block">
{`{
  "success": true,
  "data": {
    "lead_id": "LEAD_UUID",
    "status_id": "STATUS_UUID"
  }
}`}
      </pre>
    </div>
  );
};

export default ApiGettingStarted;